// @flow

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import DefaultLmis from './DefaultLmis/DefaultLmis';

const mapStateToProps = ({ lmis: { isDynamic, content }, location: { locale } }) => {
  return {
    isDynamic,
    content,
    locale
  };
};

const createMarkup = html => {
  return {
    __html: html
  };
};

@connect(mapStateToProps)
export default class Lmis extends Component {

  static propTypes = {
    locale: PropTypes.string.isRequired,
    isDynamic: PropTypes.bool.isRequired,
    content: PropTypes.string.isRequired
  };

  render() {
    const { isDynamic, content, locale } = this.props;

    /* eslint-disable react/no-danger */
    return (
      isDynamic ?
        <div dangerouslySetInnerHTML={createMarkup(content)} data-automation="dynamic-lmis" /> :
        <DefaultLmis {...{ locale }} />
    );
    /* eslint-enable react/no-danger */
  }
}



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/Lmis/Lmis.js
 **/